import { axiosInstance } from '../axiosInstance';
import { GET_CATS, CATS_LOADING, CATS_FAIL } from './types.js';
import { returnErrors, clearErrors } from '../actions/errorActions';

export const getCats = (locale) => {
    return async function(dispatch){
        dispatch(clearErrors());
        dispatch({
            type: CATS_LOADING
        });
        const config = {
            headers: {
                "Content-type": "application/json",
                "Accept-Language": locale ? locale : "en"
            }
        }
        try {
            let response = await axiosInstance.get(
                '/api/categories',
                config
            );
            if(response.status !== 200){
                dispatch({
                    type: CATS_FAIL,
                });
                throw Error({
                    response: {
                        data: "Other Errors",
                        status: "Other Errors"
                    },
                })
            }else{
                dispatch({
                    type: GET_CATS,
                    payload: response.data.data
                })
            }
        } catch (error) {
            if (error.response && error.response.data) {
                dispatch(returnErrors(error.response.data, error.response.status, 'CATS_FAIL'));
                dispatch ({ 
                    type: CATS_FAIL 
                });
            }else{
                let errorJson = JSON.stringify(error);
                let errorParsed = JSON.parse(errorJson);
                return (
                    dispatch(returnErrors(errorParsed.message, "Network Error", 'CATS_FAIL')),
                    dispatch ({ 
                        type: CATS_FAIL 
                    })
                )
            }
        }
    }
};